module.exports = __webpack_public_path__ + "static/media/public_active_1.9fc1f542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin/public_active_1.png
// module id = 3478
// module chunks = 0